import React, { memo } from "react";
import Widget from "../Widget";
import CommentsTable from "components/Admin/Tables/CommentsTable";

const CommentsWidget = () => {
  return (
    <Widget title="Ревюта">
      <CommentsTable />
    </Widget>
  );
};

export default CommentsWidget;
